import { render } from "./NewspaperSection.vue?vue&type=template&id=1373d636&scoped=true"
import script from "./NewspaperSection.vue?vue&type=script&lang=js"
export * from "./NewspaperSection.vue?vue&type=script&lang=js"

import "./NewspaperSection.vue?vue&type=style&index=0&id=1373d636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1373d636"]])

export default __exports__